
import { Component, Vue, Provide } from "vue-property-decorator";
@Component({
  name: "App",
})
export default class extends Vue {
  public isRouterAlive = true;
  @Provide()
  public switchOver = this.reload;
  public reload() {
    this.isRouterAlive = false;
    this.$nextTick(() => {
      this.isRouterAlive = true;
    });
  }
}
